import React from "react";
import "./Golf.css";
import golf from "../../img/about/golf.png";

function Golf() {
  return (
    <div className="Golf">
    <div className="Golf__mobile__img">
    <img src={golf} alt="Luxury villa with sea view in Costa Blanca, Spain" />
    </div>
      <div className="Golf__img">
      <img src={golf} alt="Luxury villa with sea view in Costa Blanca, Spain" />
      </div>
      <div className="Golf__txt">
      <h1>Golf Sports: La Sella Golf</h1>
      <p>
        Located in Denia, this course is surrounded by the Montgó Natural Park.
        It offers a challenging 27-hole layout designed by José María Olazábal,
        suitable for players of all skill levels. Club de Golf Don Cayo:
        Situated in Altea, Club de Golf Don Cayo offers a picturesque 9-hole
        course nestled between the sea and the mountains.
        <br /><br />
         Despite being a
        smaller course, it provides an enjoyable round with stunning views of
        the Mediterranean coastline. Jávea Golf Club offers a challenging 9-hole
        course surrounded by lush vegetation and stunning scenery. The course is
        suitable for players of all levels and provides a relaxed atmosphere for
        golfers to enjoy.
      </p>
      </div>
      
     
    </div>
  );
}

export default Golf;
